import React from 'react'
import { Text } from '@usap/uicomponents'

const PartNo = props => {
  const { selectedPart, partNumber, isWmoEnabled = false } = { ...props }
  if (!selectedPart) {

    if(isWmoEnabled) {
      return (
        <Text
          color="dark-2"
          style={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px" }}
        >
          {'Part Number: '}
          {partNumber}
        </Text>
      )
    }

    return (
      <Text
        size="small"
        color="#666666"
        style={{ fontWeight: 400, lineHeight: 1.5, marginBottom: '12px' }}
      >
        {'Part no.: '}
        {partNumber}
      </Text>
    )
  }
  return null
}

export default PartNo
